import styled from '@emotion/styled'

export const StyledSeperator = styled.div`

    /* direction: rtl; */

`